import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['content']

  reveal() {
    this.contentTarget.classList.toggle('hidden')
  }
}
